<template>
  <div>
      <div class="spin-load">
          <!--      <Spin fix>-->
          <!--        <Icon type="ios-loading" size=30 class="spin-icon-load"></Icon>-->
          <!--        <p>Loading...</p>-->
          <!--        <p>{{id}}</p>-->
          <!--      </Spin>-->
      </div>
  </div>
</template>

<script>
  import Fingerprint2 from "fingerprintjs2";
  
  export default {
      name: "loading",
      data() {
          return {
              code: '',
              id: '',
          }
      },
      methods: {
          getId: function () {
              //获取唯一id
              Fingerprint2.get(components => {
                  let murmur = Fingerprint2.x64hash128(
                      components
                          .map(function (pair) {
                              return pair.value;
                          })
                          .join(),
                      "115109111107"
                  );
                  this.id = murmur;
              });
          },
          getainfo() {
              let _me = this;
              // alert(_me.id);
              let params = {
                  access_key: ACCESS_KEY,
                  device: _me.id,
                  info_code: _me.code,
                  type: K_TYPE
              };
              _me.common.httpPost('anti/fake/info/a', params)
                  .then((res) => {
                      let text = _me.common.language ? res.message.split('|')[0] : res.message.split('|')[1];
                      if (res.code == '852003' || res.code == '852007') {
                          //产品不是正品
                          _me.$router.push({name: 'A_fake', params: {text: text}});
                      } else if (res.code == '852006') {
                          //产品未激活
                          res.data.device = _me.id;
                          _me.$router.push({name: 'A_nonactivate', params: {data: res.data}});
                      } else if (res.code == '852005' || res.code == '852008') {
                          //产品已激活
                          _me.$router.push({name: 'A_activate', params: {data: res.data}});
                      } else if (res.code == '852004') {
                          //产品无记录
                          _me.$router.push({name: 'A_nonrecord', params: {text: text}});
                      } else {
                          text = text == undefined ? res.message : text;
                          _me.$router.push({name: 'A_error', params: {text: text}})
                      }
                  })
                  .catch(err => {
                      this.$Notice.warning({
                          title: err,
                      });
                  });
          },
          toHome() {
              this.$router.push({name: 'Home'});
          }
      },
      created() {
          this.code = K_A_PREV + this.$route.params.code;
          this.getId();
      },
      watch: {
          id: function (val, oldVal) {
              this.getainfo();
          }
      }
  }
</script>

<style scoped>
  .spin-load {
      height: 100vh;
      position: relative;
      border: 1px solid #eee;
  }
  
  .spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
  }
  
  .spin-load p {
      margin-top: 0.5rem;
      font-size: 1rem;
  }
</style>
